/* eslint-disable */

var icon = require('vue-svgicon')
icon.register({
  'hours': {
    width: 15,
    height: 15,
    viewBox: '0 0 15 15',
    data: `<path pid="0" d="M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zm.538-12H7v4.801L9.266 10 10 9.281l-1.962-1.9V3z"/>`
  }
})
